import { useEffect } from "react";
import { useBrand } from "../lib/brand";

// Ajuste dynamiquement UNIQUEMENT les ressources PWA (manifest, favicon, apple-touch-icon).
// Les balises SEO (title, description, og:*, twitter:*, canonical, robots) sont désormais
// gérées par :
//   • index.html (valeurs par défaut Nold Go + bascule inline BentSkin sur bentskingo.*)
//   • <SEOHead /> (par page critique, via react-helmet-async)
// Ainsi, plus de conflit entre plusieurs sources qui écriraient les mêmes meta.
export function BrandMeta() {
  const { isEurope } = useBrand();

  useEffect(() => {
    const manifest = document.querySelector('link[rel="manifest"]');
    if (manifest) {
      // Sur /restaurateur, on sert un manifeste dédié (scope + start_url = /restaurateur, shortcuts métier).
      const isResto = typeof window !== "undefined" && (window.location.pathname || "").startsWith("/restaurateur");
      manifest.setAttribute("href", isResto ? "/manifest-restaurateur.json" : (isEurope ? "/manifest-europe.json" : "/manifest.json"));
    }

    const apple = document.querySelector('link[rel="apple-touch-icon"]');
    if (apple) apple.setAttribute("href", isEurope ? "/nold-icon.jpg?v=7" : "/apple-touch-icon.png");

    // Favicon dynamique : nold-icon.jpg sur noldgo, icon-192.png sur bentskingo
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) favicon.setAttribute("href", isEurope ? "/nold-icon.jpg?v=7" : "/icon-192.png");
  }, [isEurope]);

  return null;
}
